import { FunnelEventsTracking } from 'saddlebag-user-tracking-events';

import { isProdEnv } from '../../../utils/isEnv';
import logger from '../../services/logger';

export const coordToGeoMeasurement = (coordinate) => {
  if (!coordinate) return null;
  const coordinateString = coordinate.toString();

  const splitResult = coordinateString.split('.');

  let precision;
  if (splitResult.length > 1) precision = splitResult[1].length;
  else precision = 0;
  const amount = parseFloat(coordinateString) * 10 ** precision;
  return {
    precision,
    amount,
  };
};

class FunnelEventsClient {
  constructor(tracker) {
    const env = isProdEnv() ? 'public' : 'public-sandbox';
    this.tracker = tracker || new FunnelEventsTracking(env, 'hotels-website');
  }

  trackSearch({
    adm1,
    adm2,
    city,
    entityId,
    lat,
    lon,
    name,
    nation,
    requestId,
    skyscannerNodeCode,
    stay,
    type,
  }) {
    try {
      this.tracker.track(isProdEnv() ? 'clients.Search' : 'sandbox.Search', {
        business_domain: 'HOTEL',
        destination: {
          location_attribute: {
            location_attribute_encoding: skyscannerNodeCode
              ? 'SS_GEO1_ID'
              : 'DDB_ID',
            location_id: skyscannerNodeCode || entityId.toString(),
            location_name: name,
            location_descriptor_level: type,
            location_descriptors: {
              NATION: nation,
              CITY: city,
              ADM1: adm1,
              ADM2: adm2,
            },
          },
          geo: {
            latitude_int: coordToGeoMeasurement(lat),
            longitude_int: coordToGeoMeasurement(lon),
          },
        },
        start_date: {
          unix_time_millis: stay.checkIn.getTime(),
          date_time_kind: 'DAY',
        },
        end_date: {
          unix_time_millis: stay.checkOut.getTime(),
          date_time_kind: 'DAY',
        },
        hotel_search: {
          adults: stay.numberOfAdults,
          rooms: stay.numberOfRooms,
          request_id: requestId,
        },
      });
    } catch (err) {
      logger.error('Failed to track trusted funnel event', null, err);
    }
  }
}

export default FunnelEventsClient;
